import { render, staticRenderFns } from "./top_banner_text.vue?vue&type=template&id=3655a0be&scoped=true"
import script from "./top_banner_text.vue?vue&type=script&lang=js"
export * from "./top_banner_text.vue?vue&type=script&lang=js"
import style0 from "./top_banner_text.vue?vue&type=style&index=0&id=3655a0be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3655a0be",
  null
  
)

export default component.exports